import { takeLatest, select, cancel, put } from 'redux-saga/effects';
import size from 'lodash/size';

import * as scheduledCompletedTasks from '../requests/scheduled-tasks-completed-req';
import {
  selectScheduledCompletedTasksCount,
  selectScheduledCompletedTasks,
  selectScheduledCompletedTasksPagination,
  selectScheduledCompletedTasksPaginationSending,
} from '../selectors';

function* loadMoreCompletedTasks({ payload }) {
  const paginationSending = yield select(
    selectScheduledCompletedTasksPaginationSending,
  );
  const pagination = yield select(selectScheduledCompletedTasksPagination);
  const counter = yield select(selectScheduledCompletedTasksCount);
  const list = yield select(selectScheduledCompletedTasks);
  const listSize = size(list);

  if (counter <= listSize || paginationSending) {
    yield cancel();
  }

  yield put(
    scheduledCompletedTasks.paginationActions.send({
      ...payload,
      ...pagination,
      offset: listSize,
    }),
  );
}

export default function* scheduledTasksPagination() {
  yield takeLatest(
    [scheduledCompletedTasks.consts.LOAD_MORE],
    loadMoreCompletedTasks,
  );
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/completed-tasks-pagination.js